import { StyleSheet } from '@react-pdf/renderer'
import { styleConfig } from '../config'
const { fontSize } = styleConfig

const styles = StyleSheet.create({
	container: {
		width: '100%',
		marginBottom: '10mm',
	},
	row: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
	},
	column: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	th: {
		fontSize: fontSize,
		fontFamily: 'Inter',
	},
	td: {
		fontSize: fontSize,
		textAlign: 'left',
	},
	tdMain: {
		justifyContent: 'center',
	},
})

export default styles
